export default class Modal {
  constructor(modalId) {
    this.modalId = modalId
    this.element = document.getElementById(modalId)
  }

  init() {
    window.onclick = event => {
      if (event.target == this.element) this.close()
    }

    document.querySelectorAll(`[data-target="${this.modalId}"]`).forEach(openButton => {
      openButton.onclick = event => this.open(event)
    })

    document.querySelectorAll(`[data-dismiss="${this.modalId}"]`).forEach(closeButton => {
      closeButton.onclick = () => this.close()
    })
  }

  open(event) {
    event.preventDefault()

    if (this.element) this.element.style.display = 'block'
  }

  close() {
    if (this.element) this.element.style.display = 'none'
  }
}
